export default "__VITE_ASSET__DTivSOrS__"